/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'up': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 0C228.693 0 0 228.693 0 512s228.693 512 512 512 512-228.693 512-512S795.307 0 512 0zm279.893 556.373c-34.133 34.134-95.573 34.134-129.706 0L614.4 508.587v276.48c0 58.026-44.373 102.4-102.4 102.4s-102.4-44.374-102.4-102.4V512l-44.373 44.373c-34.134 34.134-95.574 34.134-129.707 0-37.547-37.546-37.547-95.573 0-129.706l235.52-235.52c23.893-23.894 61.44-23.894 85.333 0l235.52 235.52c17.067 17.066 27.307 40.96 27.307 64.853s-10.24 47.787-27.307 64.853z" _fill="#dbdbdb"/>'
  }
})
